import type { ColProps } from 'react-bootstrap';
import { Col, Card, Row } from 'react-bootstrap';
import classNames from 'classnames';
import type { ElementType, ReactNode } from 'react';

type ColBreakpoint = keyof Pick<ColProps, 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'>;

interface TitleProps {
  titleTag?: ElementType;
  className?: string;
  breakPoint?: ColBreakpoint;
  children?: ReactNode;
}

const Title = ({
  titleTag: TitleTag = 'h5',
  className,
  breakPoint,
  children
}: TitleProps) => (
  <TitleTag
    className={classNames(
      {
        'mb-0': !breakPoint,
        [`mb-${breakPoint}-0`]: !!breakPoint
      },
      className
    )}
  >
    {children}
  </TitleTag>
);

export interface FalconCardHeaderProps {
  title?: ReactNode;
  light?: boolean;
  titleTag?: ElementType;
  titleClass?: string;
  className?: string;
  breakPoint?: ColBreakpoint;
  endEl?: ReactNode;
  children?: ReactNode;
}

const FalconCardHeader = ({
  title,
  light,
  titleTag,
  titleClass,
  className,
  breakPoint,
  endEl,
  children
}: FalconCardHeaderProps) => (
  <Card.Header className={classNames(className, { 'bg-body-tertiary': light })}>
    {endEl ? (
      <Row className="align-items-center g-2">
        <Col>
          <Title
            breakPoint={breakPoint}
            titleTag={titleTag}
            className={titleClass}
          >
            {title}
          </Title>
          {children}
        </Col>
        <Col
          {...({
            [breakPoint ?? 'xs']: 'auto'
          } as Pick<ColProps, ColBreakpoint>)}
          className={`text${breakPoint ? `-${breakPoint}` : ''}-right`}
        >
          {endEl}
        </Col>
      </Row>
    ) : (
      <>
        <Title breakPoint={breakPoint} titleTag={titleTag} className={titleClass}>
          {title}
        </Title>
        {children}
      </>
    )}
  </Card.Header>
);

export default FalconCardHeader;
